import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../../../hooks/hooks';
import PageLoader from '../../../../../../../../components/PageLoader';
import GatewayCockpitInsightComponent from '../components/insights.component';
import { selectProductInsightsQueryItems } from '../../../../../../../../redux/product-insights/selector';
import { productInsights } from '../../../../../../../../redux/product-insights/action';

const ManagementGatewayCockpitInsightsEdge = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const insightsEdgesQueryData = useSelector(selectProductInsightsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectedInsightsEdges, setSelectedInsightsEdges] = useState<any>([])

    const fetchGatewayCockpitInsightQueryById = () => {
        dispatch(productInsights.query({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/insights/fetch-detail`,
            entity: 'productInsights',
            jsonData:
            {
                Context: {},
                Records: [
                    {
                        Id: Number(parmas?.id),
                        InsightsTypeId: 10
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    useEffect(() => {
        if (parmas?.id && typeof parmas?.id === 'string') {
            fetchGatewayCockpitInsightQueryById()
            setIsLoading(false)
        } else {
            setIsLoading(false)
        }
    }, [parmas?.id]
    )

    useEffect(() => {
        if (isQuery) {
            setSelectedInsightsEdges(insightsEdgesQueryData?.result?.items)
        }
    }, [isQuery]
    )

    const back = () => {
        navigate(-1)
    }

    return (
        <>
            {insightsEdgesQueryData?.isLoading ? <PageLoader /> :
                <GatewayCockpitInsightComponent
                    selectedInsightsEdges={selectedInsightsEdges}
                    back={back}
                />
            }
        </>
    )
}

export default ManagementGatewayCockpitInsightsEdge;